import React from 'react';
import classnames from 'classnames';

import './index.scss';

interface ISectionHeaderProps extends IBaseProps {
  title: React.ReactNode;
  actionText?: React.ReactNode;
  icon?: string;
  iconAlt?: string;
  variant?: 'default' | 'features';
  showAction?: boolean;
  onActionClick?: () => void;
}

const SectionHeader: React.FC<ISectionHeaderProps> = (props) => {
  const {
    style,
    className,
    title,
    actionText,
    icon,
    iconAlt,
    variant = 'default',
    showAction = false,
    onActionClick,
  } = props;

  const hasActionText = actionText !== undefined && actionText !== null && actionText !== '';

  return (
    <div
      style={style}
      className={classnames('dbh-section-header', className, {
        'dbh-section-header--features': variant === 'features',
      })}
    >
      <div className="dbh-section-header__title-wrap">
        {icon && <img className="dbh-section-header__title-icon" src={icon} alt={iconAlt || ''} />}
        <div className="dbh-section-header__title">{title}</div>
      </div>
      {showAction && hasActionText && (
        <div
          className="dbh-section-header__action"
          onClick={(e) => {
            e.stopPropagation();
            onActionClick?.();
          }}
        >
          {actionText}
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
